import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", title: "Book a free consult", desc: "A 20-minute call to map your workflow, EHR, and exact support gaps." },
  { n: "02", title: "Meet your VMA", desc: "We match you with a HIPAA-trained assistant experienced in your specialty." },
  { n: "03", title: "48-hour onboarding", desc: "EHR access, SOP training, and phone integration — live within two days." },
  { n: "04", title: "Go live & scale", desc: "Daily shift logs, weekly audits, and a US account manager as you grow." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-20 lg:py-28" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <Eyebrow>How It Works</Eyebrow>
        <h2 className="mt-4 max-w-xl font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight text-[#0F1E19]">
          From consult to chart-ready in 48 hours.
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-10 md:grid-cols-4" data-testid="how-steps">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div className="relative" data-testid={`how-step-${i}`}>
              {i < STEPS.length - 1 && (
                <div className="absolute left-10 top-6 hidden h-px w-[calc(100%-2.5rem)] bg-[#0F1E19]/10 md:block" />
              )}
              <div className="relative flex h-12 w-12 items-center justify-center rounded-full border border-[#0A3B2C]/25 bg-white">
                <span className="font-mono text-sm font-semibold text-[#0A3B2C]">{s.n}</span>
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold text-[#0F1E19]">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4A5D55]">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
